import { Row, Col , Form} from "react-bootstrap";
import { useEffect, useState } from "react";
import { useAlert } from "../../../hooks/useAlert";
import AlertMessage from "../../../components/AlertMessage";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from "react-redux";
import { setFilterByCurrentUser } from "../../../redux/filtersSlice";
import { addAuditLog } from "../../auditLogs/api/auditApi";
import { RootState } from "../../../redux/store";
import ClaimSatusLineChart from "../components/dashboard/ClaimSatusLineChart";
import ClaimsServiceIndicatorBarChart from "../components/dashboard/ClaimsServiceIndicatorBarChart";
import ClaimsStatusPieChart from "../components/dashboard/ClaimsStatusPieChart";
import TopicClaims from "../components/dashboard/topics/TopicClaims";
import { ClaimTimelineKPIs } from "../components/dashboard/ClaimTimelineKPIs";
import { ClaimIndicatorsTimeTracking } from "../components/dashboard/ClaimIndicatorsTimeTracking";
import { useOutletContext } from "react-router-dom";
import { DashboardOutletContext } from "../../../components/Layouts/GlobalDashboardLayout";

export default function DashboardClaim() {
    const { t } = useTranslation('common');
    const dispatch = useDispatch();
    const [message, setMessage] = useState<string | undefined>();
    const { alert, hideAlert, showAlert, isVisible } = useAlert({ fromLocation: false });
    const { filterByCurrentUser } = useSelector((state: RootState) => state.filters.claims);
    const { section1Ref, section2Ref, section3Ref } = useOutletContext<DashboardOutletContext>();

    useEffect(() => {
        addAuditLog({
            entity: 'Claim'
        });
    }, [])

    useEffect(() => {
        if (!message) return; 
        showAlert({
            message: message,
            type: 'danger',
            duration: 8000
        });
           
    }, [message, showAlert]);

    const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(setFilterByCurrentUser({ table: 'claims', filterByCurrentUser: e.target.checked }));
    }

    return (<>
        <Form>
            <Form.Check
                className="my-4"
                type="switch"
                id="custom-switch"
                label={t("common:buttons.toggleAssignUser")}
                checked={filterByCurrentUser}
                onChange={handleToggle}
            />
        </Form>
        <Row>
            <Col className="text-center" xs={12} md={12}>
                {isVisible && (
                    <AlertMessage
                        message={alert!.message}
                        type={alert!.type}
                        onClose={hideAlert}
                    />
                )}
            </Col>
        </Row>
        <Row ref={section1Ref}>
            <Col xs={12}>
                <ClaimTimelineKPIs />
            </Col>
        </Row>
        <Row className="mt-3" ref={section2Ref}>
            <Col xs={6} md={6}>
                <ClaimsStatusPieChart setMessage={setMessage} />
            </Col>
            <Col xs={6} md={6} >
                <TopicClaims />
            </Col>
        </Row>
        <div ref={section3Ref}>
            <Row >
                <Col>
                    <ClaimIndicatorsTimeTracking />
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xs={6} md={6}>
                    <ClaimsServiceIndicatorBarChart setMessage={setMessage} />
                </Col>
                <Col xs={6} md={6}  >
                    <ClaimSatusLineChart setMessage={setMessage} />
                </Col>
            </Row>
        </div>
        </>
    );
}